/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* khm adding contact form to template page placeholder */



let contactForm = document.getElementById("contact_form");
let featureText = document.getElementsByClassName("FeatureText__ContentWrapper");

if(featureText.length>0 && contactForm!=null)
{
  featureText[0].appendChild(contactForm);
  contactForm.style.display = "block";
}
 


appendChildbyClassName("Article__MetaItem", "SectionHeader__Description");
appendChildbyClassName("Article__Title", "SectionHeader__Heading");
//appendChildbyClassName("Article__Image", "SectionHeader__Description");

function appendChildbyClassName(source, target){
let sourceDom = document.getElementsByClassName(source);
let targetDom = document.getElementsByClassName(target); 
  
  if (sourceDom.length>0 && targetDom.length>0)
  {
    targetDom[0].innerHTML="";
    targetDom[0].appendChild(sourceDom[0]);
    targetDom[0].style.display = "block";
    sourceDom[0].style.display = "block";
  }
}